import { render, staticRenderFns } from "./RecaudacionOtroIngreso.vue?vue&type=template&id=707c5220&scoped=true"
import script from "./RecaudacionOtroIngreso.vue?vue&type=script&lang=ts"
export * from "./RecaudacionOtroIngreso.vue?vue&type=script&lang=ts"
import style0 from "./RecaudacionOtroIngreso.vue?vue&type=style&index=0&id=707c5220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c5220",
  null
  
)

export default component.exports